<template>
  <permissions-checkbox v-model="value" v-bind="$attrs"></permissions-checkbox>
</template>

<script>
import { get } from 'vuex-pathify';

import PermissionsCheckbox from '@/components/PermissionsCheckbox';

export default {
  name: 'PermissionsCheckboxUsers',
  components: {
    PermissionsCheckbox,
  },
  props: {
    group: {
      type: String,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    valueKey: {
      type: String,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    currentGroupPermissions: get('users/currentGroupPermissions'),
    value: {
      get() {
        const key = this.group === 'modules' ? 'module_name' : 'layer_id';
        return this.currentGroupPermissions[this.group].find(permission => permission[key] === this.id)[this.valueKey];
      },
      set(nV) {
        const { group, id, valueKey } = this;
        this.$store.set('users/SET_CURRENT_GROUP_PERMISSIONS_VALUE!', { group, id, valueKey, value: nV });
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(nV) {
        this.$emit('update:value', nV);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
  margin: 0px;
  padding: 0px;
  ::v-deep .v-input__slot {
    margin-bottom: 0;
  }
  ::v-deep .v-input--selection-controls__input {
    margin-right: 0;
  }
}
</style>
